import cloneDeep from "lodash/cloneDeep";
import { InstancedMesh, Mesh, Scene } from "three";
import { createMeshesFromInstancedMesh } from "three/examples/jsm/utils/SceneUtils.js";
export class BaseExporter {
    documentData;
    documentOwner;
    constructor(documentData, documentOwner) {
        // QUESTION: why clone here???
        this.documentOwner = cloneDeep(documentOwner);
        this.documentData = cloneDeep(documentData);
    }
    /**
     * Basic function to find the correct value property based on the part type.
     * The matching is dumb but getting it wrong is low impact - elements with
     * missing or weird sets of properties just won't be grouped together.
     *
     * TODO: revisit this once we can model these relationships in property definitions.
     */
    static getValueProperty(row) {
        if (row["Part Type"]?.match(/Capacitor/)) {
            return "Capacitance";
        }
        else if (row["Part Type"]?.match(/Resistor/)) {
            return "Resistance";
        }
        else if (row["Part Type"]?.match(/Inductor/)) {
            return "Inductance";
        }
        else {
            return undefined;
        }
    }
    createFileName(extension, postfix) {
        let filename = `${this.documentOwner.handle} - ${this.documentData.slug}`;
        if (postfix) {
            filename = `${filename} - ${postfix}`;
        }
        filename = this.createValidFileString(filename);
        if (extension) {
            const validExtension = this.createValidFileString(extension);
            filename = `${filename}.${validExtension}`;
        }
        return filename;
    }
    isSymbolElement(part) {
        return !!part.symbol_resource_file;
    }
    makeMetaDataInvisible(object) {
        object.traverse((object) => {
            if (object.userData.metaData) {
                object.visible = false;
            }
        });
        return object;
    }
    normalizeInstancedMeshes(input) {
        const scene = new Scene();
        input.traverse((object) => {
            if (object instanceof InstancedMesh) {
                const nonMeshInstanceObject = createMeshesFromInstancedMesh(object);
                scene.add(nonMeshInstanceObject);
                object.visible = false;
            }
        });
        scene.add(input);
        return scene;
    }
    deepCloneObject3d(input) {
        const clonedInput = input.clone(true);
        clonedInput.traverse((object) => {
            if (object instanceof InstancedMesh || object instanceof Mesh) {
                if (object.material) {
                    if (
                    // It's possible for Array.isArray(object.material) to return false, even when object.material is an
                    // iterable Array-like object. I believe the issue stems from Object3D::clone()'s internal behavior,
                    // specifically the way the array of materials for a multi-material object, is instantiated. Checking
                    // for instanceof Array as well covers the case where Array.isArray(..) would otherwise return false.
                    Array.isArray(object.material) ||
                        object.material instanceof Array) {
                        object.material = object.material.map((material) => {
                            return material.clone();
                        });
                    }
                    else {
                        object.material = object.material.clone();
                    }
                }
            }
        });
        return clonedInput;
    }
    createValidFileString(fileString) {
        return fileString.replace(/[ &\/\\#,+()$~%.'":*?<>{}]/g, "");
    }
}
//# sourceMappingURL=BaseExporter.js.map